<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>Faltas Médicas</h2>
                    </div>
                    <div class="menu-painel">
                        <button mat-stroked-button color="primary" (click)="add()" matTooltip="Criar">Novo
                        </button>
                    </div>
                </div>
                <div class="panel-body" (window:resize)="onResize($event)">

                    <form [formGroup]="formularioDeConsultaDeFaltaMedica" (ngSubmit)="onSubmit()"
                        (keydown.enter)="$event.preventDefault()">

                        <div class="form-row">

                            <mat-form-field class="form-group col-lg-6 col-md-6 col-sm-12 col-12">
                                <mat-label>Data Inicial e Final</mat-label>

                                <mat-date-range-input [rangePicker]="picker">
                                    <input matStartDate placeholder="Data Inicial" required
                                        formControlName="dataInicial">
                                    <input matEndDate placeholder="Data Final" required formControlName="dataFinal">
                                </mat-date-range-input>

                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>

                                <mat-error
                                    *ngIf="formularioDeConsultaDeFaltaMedica.controls.dataInicial.hasError('matStartDateInvalid')">
                                    O campo Data Inicial está inválido.
                                </mat-error>
                                <mat-error
                                    *ngIf="formularioDeConsultaDeFaltaMedica.controls.dataFinal.hasError('matEndDateInvalid')">
                                    O campo Data Final está inválido.
                                </mat-error>

                                <mat-error
                                    *ngIf="formularioDeConsultaDeFaltaMedica.controls.dataInicial.hasError('required')">
                                    O campo Data Inicial é obrigatório.
                                </mat-error>
                                <mat-error
                                    *ngIf="formularioDeConsultaDeFaltaMedica.controls.dataFinal.hasError('required')">
                                    O campo Data Final é obrigatório.
                                </mat-error>
                            </mat-form-field>

                            <div class="form-group col-lg-2 col-md-2 col-sm-12 col-12" style="align-self: center;">
                                <button mat-raised-button color="success" type="submit" matTooltip="Consultar"
                                    [disabled]="!formularioDeConsultaDeFaltaMedica.valid" style="width: 100%;">
                                    Consultar
                                </button>
                            </div>

                        </div>
                    </form>

                    <div class="form-row">
                        <div class="form-group col-lg-12 col-md-12 col-sm-12 col-12">
                            <mat-form-field fxFlex="100%">
                                <input matInput type="text" (keyup)="doFilter($event)" placeholder="Filtrar">
                            </mat-form-field>
                        </div>
                    </div>
                    <table mat-table [dataSource]="dataSource" matSort class="table table-striped">
                        <ng-container matColumnDef="nomeMedico">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Médico </th>
                            <td mat-cell *matCellDef="let faltaMedica"> {{faltaMedica.nomeMedico}} </td>
                        </ng-container>

                        <ng-container matColumnDef="dataFalta">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Data </th>
                            <td mat-cell *matCellDef="let faltaMedica"> {{faltaMedica.dataFalta | date:"dd/MM/yyyy"}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="horaFalta">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Hora </th>
                            <td mat-cell *matCellDef="let faltaMedica"> {{horaFormatada(faltaMedica.horaFalta)}} </td>
                        </ng-container>

                        <ng-container matColumnDef="tipoFaltaFormatado">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Tipo Falta </th>
                            <td mat-cell *matCellDef="let faltaMedica"> {{faltaMedica.tipoDeFaltaFormatada()}} </td>
                        </ng-container>

                        <ng-container matColumnDef="details">
                            <th mat-header-cell *matHeaderCellDef class="table-column-center"> Ações </th>
                            <td mat-cell *matCellDef="let faltaMedica" class="table-column-center">
                                <button mat-icon-button color="primary" (click)="details(faltaMedica.id)"
                                    matTooltip="Detalhar">
                                    <mat-icon class="mat-18">info</mat-icon>
                                </button>
                                <button mat-icon-button color="primary" (click)="update(faltaMedica.id)"
                                    matTooltip="Alterar">
                                    <mat-icon class="mat-18">edit</mat-icon>
                                </button>
                                <button mat-icon-button color="warn" (click)="confirmDelete(faltaMedica.id)"
                                    matTooltip="Remover">
                                    <mat-icon class="mat-18">delete</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 30, 50, 70, 100]" showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>
        </div>
    </div>
</div>